export default "__VITE_ASSET__BgNDyWBj__"